import WebApp from '@twa-dev/sdk';

import { getCookie, parseJwt } from '../../helpers';

const isTokenValid = (token: string): boolean => {
  if (!token) return false;

  const parsed = parseJwt(token);

  if (!parsed) return false;

  const isTokenExpired = parsed.exp * 1000 <= Date.now();
  const isUserNameMatch =
    parsed.username === WebApp?.initDataUnsafe.user?.username ||
    !WebApp?.initDataUnsafe.user;

  return isUserNameMatch && !isTokenExpired;
};

export const getTokenPresaved = () => {
  const presaved =
    new URLSearchParams(document.location.search).get('token') ?? getCookie('token');

  const isTokenOK = presaved ? isTokenValid(presaved) : false;
  return isTokenOK ? presaved : null;
};
